import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useRef, useState } from 'react'
import { getPreference as getPreferenceUntyped } from '@fs/zion-preferences'
import type { getPreference } from '@fs/zion-tree-types/zion-preferences'
import { type SortBy, type SortDirection } from '../types/privatePersons'

const getPreferenceTyped = getPreferenceUntyped as typeof getPreference

const DIRECTION_KEY = 'private.direction'
const SORT_KEY = 'private.sort'

type ReturnValue = {
  setSortBy: Dispatch<SetStateAction<SortBy>>
  sortBy: SortBy
  setSortDirection: Dispatch<SetStateAction<SortDirection>>
  sortDirection: SortDirection
  loading: boolean
}

export default function usePrivatePersonsSort(isSorting?: boolean): ReturnValue {
  const [sortBy, setSortBy] = useState<SortBy>('fullName')
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc')
  const [loading, setLoading] = useState(!!isSorting)
  const hasFetched = useRef(false)

  useEffect(() => {
    let isCurrent = true
    if (isSorting && !hasFetched.current) {
      hasFetched.current = true
      getPreferenceTyped<{ [DIRECTION_KEY]: SortDirection; [SORT_KEY]: SortBy }>(DIRECTION_KEY, SORT_KEY)
        .then((prefs) => {
          if (isCurrent) {
            prefs?.[SORT_KEY]?.value && setSortBy(prefs[SORT_KEY].value)
            prefs?.[DIRECTION_KEY]?.value && setSortDirection(prefs[DIRECTION_KEY].value)
            setLoading(false)
          }
        })
        .catch((error) => {
          console.error(error)
          setLoading(false)
        })
    }
    return () => {
      isCurrent = false
    }
  }, [isSorting])

  return {
    setSortBy,
    sortBy,
    sortDirection,
    setSortDirection,
    loading,
  }
}
